import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import GoogleSVG from "./Google.svg.jsx";
import { buttonCss } from "./GoogleAnchor.style";

const propTypes = {
  children: PropTypes.string.isRequired,
  __cssFor: PropTypes.object,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const GoogleAnchor = ({ children, __cssFor = {}, ...props }) => {
  return (
    <AnchorWithTrackEvent
      __cssFor={{ ...buttonCss, ...__cssFor }}
      icon={{
        SvgComponent: GoogleSVG,
        isIconBeforeText: true,
      }}
      objectType={objectTypes.user}
      actionName={actionNames.select}
      dataProps={{
        "data-qa-selector": "sign-in-with-google",
      }}
      streamProperties={{
        description:
          "Select the button allowing the user to sign in with Google",
      }}
      {...props}
    >
      <span>{children}</span>
    </AnchorWithTrackEvent>
  );
};

GoogleAnchor.propTypes = propTypes;

export default GoogleAnchor;
